<template>
    <div class="background-image">
        <div class="content-wrap">
            <div class="content-view" style="border-bottom-left-radius: 10px; border-top-left-radius: 10px;">
                <el-carousel :interval="5000" arrow="always" class="carousel-element">
                    <el-carousel-item v-for="item in adList" :key="item">
                        <img src="../../../assets/image/new_slices/lgin_picture@2x.jpg" alt=""
                            style="width: 100%; height: 100%;">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <!-- 登录区域 -->
            <div class="content-view">
                <div class="login-container">
                    <!-- 返回首页链接 -->
                    <div class="return-home" @click="handleReturnHome">
                        <img src="@/assets/image/new_slices/home@2x.png" class="home-icon" alt="">
                        <div class="return-link">返回首页</div>
                    </div>
                    <!-- 标题 -->
                    <div class="login-image">
                        <img :src="loginLogoPath" style="width: 100%; height: 100%;">
                    </div>
                    <!-- 登录表单 -->
                    <div class="login-form">
                        <!-- 密码登录表单 -->
                        <div class="password-form">
                            <div class="form-group">
                                <input type="text" placeholder="请输入登录名" class="form-input"
                                    :class="{ 'error': formErrors.loginName }" v-model="loginForm.loginName"
                                    @blur="formErrors.loginName = validateLoginName(loginForm.loginName)"
                                    @input="formErrors.loginName = ''" @keyup.enter="handleLogin" aria-label="登录名"
                                    autocomplete="username">
                                <div v-if="formErrors.loginName" class="error-message">{{ formErrors.loginName }}</div>
                            </div>
                            <div class="form-group">
                                <input type="password" placeholder="请输入密码" class="form-input"
                                    :class="{ 'error': formErrors.loginPwd }" v-model="loginForm.loginPwd"
                                    @blur="formErrors.loginPwd = validatePassword(loginForm.loginPwd)"
                                    @input="formErrors.loginPwd = ''" @keyup.enter="handleLogin" aria-label="密码"
                                    autocomplete="current-password">
                                <div v-if="formErrors.loginPwd" class="error-message">{{ formErrors.loginPwd }}</div>
                            </div>

                            <!-- 忘记密码链接 -->
                            <div class="forgot-links">
                                <a class="forgot-link" @click.prevent="showForgotUsernameModal('loginName')">忘记登录名</a>
                                <span class="separator">|</span>
                                <a class="forgot-link" @click.prevent="showForgotUsernameModal('password')">忘记密码</a>
                                <span class="separator">|</span>
                                <a class="forgot-link" @click.prevent="showPhoneUnusedModal">手机号不再使用</a>
                            </div>
                        </div>

                        <!-- 登录按钮 -->
                        <button class="login-btn" @click="handleLogin" :disabled="isLoading"
                            :aria-label="isLoading ? '登录中...' : '登录'">
                            <i v-if="isLoading" class="el-icon-loading"></i>
                            {{ isLoading ? '登录中...' : '登录' }}
                        </button>

                        <!-- 注册链接 -->
                        <div class="register-text">
                            若您尚未注册,请点击<a href="/register" target="_blank" class="register-link">注册</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 找回登录名弹窗  忘记密码 -->
        <el-dialog :title="title" :visible.sync="showForgotUsername" width="500px" :close-on-click-modal="false"
            @close="closeForgotUsernameModal">
            <form class="forgot-form" @submit.prevent="submitForgotForm">
                <!-- 验证码输入组 -->
                <div class="forgot-form-group">
                    <label class="forgot-form-label required">验证码</label>

                    <div class="forgot-input-group">
                        <input type="text" v-model="forgotForm.captcha" class="forgot-form-input" placeholder="请输入验证码"
                            required>
                        <div class="forgot-captcha-image" @click="refreshForgotCaptcha">
                            <img :src="getCaptchaImageUrl()" alt="验证码">
                        </div>
                    </div>
                </div>
                <!-- 注册手机号输入组 -->
                <div class="forgot-form-group">
                    <label class="forgot-form-label required">注册手机号</label>
                    <div class="forgot-input-group">
                        <input type="tel" v-model="forgotForm.phone" class="forgot-form-input" placeholder="请输入注册手机号"
                            required>
                    </div>
                </div>
                <!-- 手机验证码输入组 -->
                <div class="forgot-form-group">
                    <label class="forgot-form-label required">手机验证码</label>
                    <div class="forgot-input-group">
                        <input type="text" v-model="forgotForm.smsCode" class="forgot-form-input" placeholder="请输入手机验证码"
                            required>
                        <button type="button" class="forgot-sms-btn" :disabled="forgotSmsCountdown > 0"
                            @click="sendForgotSmsCode">
                            {{ forgotSmsCountdown > 0 ? forgotSmsCountdown + 's' : '获取手机验证码' }}
                        </button>
                    </div>
                </div>
                <!-- 新密码输入组 -->
                <div class="forgot-form-group" v-if="title === '找回密码'">
                    <label class="forgot-form-label required">新密码</label>
                    <div class="forgot-input-group">
                        <input type="password" v-model="forgotForm.password" class="forgot-form-input"
                            placeholder="请输入新密码（6-20位字符）" required>
                    </div>
                </div>
                <!-- 确认密码输入组 -->
                <div class="forgot-form-group" v-if="title === '找回密码'">
                    <label class="forgot-form-label required">确认密码</label>
                    <div class="forgot-input-group">
                        <input type="password" v-model="forgotForm.confirmPassword" class="forgot-form-input"
                            placeholder="请再次输入新密码" required>
                    </div>
                </div>
            </form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeForgotUsernameModal">取消</el-button>
                <el-button type="primary" @click="submitForgotForm" :loading="forgotSubmitting">确定</el-button>
            </span>
        </el-dialog>
        <!-- 投标人1 bidder  招标代理2 agent  招标人3 tenderee -->
        <!-- 手机号不再使用提示弹窗 -->
        <el-dialog title="提示" :visible.sync="showPhoneUnused" width="550px" :close-on-click-modal="false"
            @close="closePhoneUnusedModal">
            <div class="phone-unused-content">
                <p class="phone-unused-message">
                    请发申请至首页邮箱
                    <span class="email-address">hebeixiancheng@hbidding.com</span>
                    (加盖公章)进行登录名找回、密码重置。
                </p>
                <a href="#" class="download-link" @click.prevent="downloadTemplate">下载申请模板</a>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closePhoneUnusedModal">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { loginByPassword } from '@/api/modules/user'
import { getCaptcha, getSmsCode, forgetPassword } from '@/api/modules/user'
import Cookies from 'js-cookie'
import { XTXASynObject } from '@/api/ca/XTXASynObject'

export default {
    data() {
        return {
            adList: [
                "1"
            ],
            title: '找回登录名',
            isLoading: false,
            showForgotUsername: false,
            showPhoneUnused: false,
            forgotForm: {
                captcha: '',
                phone: '',
                smsCode: '',
                captchaUuid: '',  // 图形验证码UUID
                password: '',     // 新密码
                confirmPassword: '',  // 确认密码
                roleId: ''        // 角色ID
            },
            roleId: '',
            forgotCaptchaImage: '',
            forgotSmsCountdown: 0,
            forgotSmsTimer: null,
            forgotSubmitting: false,
            formErrors: {
                loginName: '',
                loginPwd: ''
            },
            loginForm: {
                loginName: '',
                loginPwd: ''
            },
            userType: ''
        }
    },
    computed: {
        loginLogoPath() {
            return this.$channelMaterial.getLoginLogoPath()
        },
        channelCode() {
            return this.$channelMaterial.getChannelCode()
        },
    },
    beforeDestroy() {
        if (this.forgotSmsTimer) {
            clearInterval(this.forgotSmsTimer)
        }
    },
    mounted() {
        this.userType = this.$route.query.type
        switch (this.userType) {
            case 'bidder':
                this.roleId = 1
                break;
            case 'agent':
                this.roleId = 2
                break;
            default:
                this.roleId = 3
                break;
        }
        this.restoreRegisterLoginCache()
    },
    methods: {       
        restoreRegisterLoginCache() {
            const cached = localStorage.getItem('registerLoginCache')
            if (!cached) {
                return
            }
            try {
                const parsed = JSON.parse(cached)
                if (parsed.roleType !== this.userType) {
                    return
                }
                this.loginForm.loginName = parsed.loginName || ''
                this.loginForm.loginPwd = parsed.loginPwd || ''
            } catch (error) {
                console.error('恢复注册登录缓存失败:', error)
            }
        },

        // 找回密码

        closeForgotUsernameModal() {

        },

        // 登录名验证
        validateLoginName(value) {
            if (!value || value.trim() === '') {
                return '请输入登录名'
            }
            if (value.length < 2) {
                return '登录名至少2个字符'
            }
            return ''
        },
        // 密码验证
        validatePassword(value) {
            if (!value || value.trim() === '') {
                return '请输入密码'
            }
            if (value.length < 6) {
                return '密码至少6个字符'
            }
            return ''
        },
        // 清空表单错误信息
        clearFormErrors() {
            this.formErrors = {
                loginName: '',
                loginPwd: ''
            }
        },
        // 打开找回登录名/密码弹窗
        showForgotUsernameModal(type) {
            this.showForgotUsername = true
            this.title = type === 'loginName' ? '找回登录名' : '找回密码'
            // 打开弹窗时获取图形验证码
            this.getForgotCaptcha()
        },
        // 关闭找回登录名/密码弹窗
        closeForgotUsernameModal() {
            this.showForgotUsername = false
            this.forgotForm = {
                captcha: '',
                phone: '',
                smsCode: '',
                captchaUuid: '',
                password: '',
                confirmPassword: '',
                roleId: ''
            }
            // 清除倒计时
            if (this.forgotSmsTimer) {
                clearInterval(this.forgotSmsTimer)
                this.forgotSmsTimer = null
            }
            this.forgotSmsCountdown = 0
        },
        // 打开手机号不再使用弹窗
        showPhoneUnusedModal() {
            this.showPhoneUnused = true
        },
        // 关闭手机号不再使用弹窗
        closePhoneUnusedModal() {
            this.showPhoneUnused = false
        },
        // 下载申请模板
        downloadTemplate() {
            const link = document.createElement('a')
            link.href = '#'
            link.download = '申请模板.docx'
            link.click()
        },
        // 获取图形验证码
        async getForgotCaptcha() {
            try {
                const res = await getCaptcha()
                if (res.code === 0) {
                    this.forgotCaptchaImage = res.data.img
                    this.forgotForm.captchaUuid = res.data.uuid
                } else {
                    this.$message.error(res.msg || '获取验证码失败')
                }
            } catch (error) {
                console.error('获取验证码失败:', error)
                this.$message.error('获取验证码失败')
            }
        },
        // 刷新找回登录名验证码
        refreshForgotCaptcha() {
            this.getForgotCaptcha()
        },
        // 发送找回登录名手机验证码
        async sendForgotSmsCode() {
            // 验证输入
            if (!this.forgotForm.phone) {
                this.$message.error('请输入手机号')
                return
            }
            if (!this.forgotForm.captcha) {
                this.$message.error('请输入图形验证码')
                return
            }
            if (this.forgotSmsCountdown > 0) return

            try {
                const data = {
                    phone: this.forgotForm.phone,
                    uuid: this.forgotForm.captchaUuid,
                    captcha: this.forgotForm.captcha,
                }
                const res = await getSmsCode(data)
                if (res.code === 0) {
                    this.$message.success('发送成功')
                    // 开始倒计时
                    this.forgotSmsCountdown = 60
                    this.forgotSmsTimer = setInterval(() => {
                        this.forgotSmsCountdown--
                        if (this.forgotSmsCountdown <= 0) {
                            clearInterval(this.forgotSmsTimer)
                            this.forgotSmsTimer = null
                        }
                    }, 1000)
                } else {
                    this.$message.error(res.msg || '发送失败')
                    // 刷新图形验证码
                    this.getForgotCaptcha()
                }
            } catch (error) {
                console.error('发送验证码失败:', error)
                this.$message.error('发送验证码失败')
                // 刷新图形验证码
                this.getForgotCaptcha()
            }
        },
        // 提交找回登录名/密码表单
        async submitForgotForm() {
            // 验证输入
            if (!this.forgotForm.captcha) {
                this.$message.error('请输入图形验证码')
                return
            }
            if (!this.forgotForm.phone) {
                this.$message.error('请输入注册手机号')
                return
            }
            if (!this.forgotForm.smsCode) {
                this.$message.error('请输入手机验证码')
                return
            }

            // 如果是找回密码，需要验证密码
            if (this.title === '找回密码') {
                if (!this.forgotForm.password) {
                    this.$message.error('请输入新密码')
                    return
                }
                if (this.forgotForm.password.length < 6 || this.forgotForm.password.length > 20) {
                    this.$message.error('密码长度应为6-20位字符')
                    return
                }
                if (!this.forgotForm.confirmPassword) {
                    this.$message.error('请确认新密码')
                    return
                }
                if (this.forgotForm.password !== this.forgotForm.confirmPassword) {
                    this.$message.error('两次输入的密码不一致')
                    return
                }

                // 调用找回密码接口
                this.forgotSubmitting = true
                try {
                    const res = await forgetPassword({
                        code: this.forgotForm.smsCode,
                        password: this.forgotForm.password,
                        phone: this.forgotForm.phone,
                        roleId: this.roleId
                    })

                    if (res.code === 200 || res.code === 0) {
                        this.$message.success('密码重置成功，请使用新密码登录')
                        this.closeForgotUsernameModal()
                    } else {
                        this.$message.error(res.msg || '密码重置失败')
                    }
                } catch (error) {
                    console.error('密码重置失败:', error)
                    this.$message.error('密码重置失败，请重试')
                } finally {
                    this.forgotSubmitting = false
                }
            } else {
                // 找回登录名逻辑（暂未实现）
                this.$message.info('找回登录名功能开发中')
                this.closeForgotUsernameModal()
            }
        },
        // 返回首页
        handleReturnHome() {
            this.$router.push('/home')
        },
        // 登录
        handleLogin() {
            const loginNameError = this.validateLoginName(this.loginForm.loginName)
            const passwordError = this.validatePassword(this.loginForm.loginPwd)
            if (loginNameError) {
                this.formErrors.loginName = loginNameError
                this.$message.error(loginNameError)
                return
            }
            if (passwordError) {
                this.formErrors.loginPwd = passwordError
                this.$message.error(passwordError)
                return
            }
            this.isLoading = true
            const loginData = {
                loginName: this.loginForm.loginName,
                loginPwd: this.loginForm.loginPwd,
                roleId: this.roleId,
                channelCode: this.channelCode
            }
            loginByPassword(loginData).then(res => {
                if (res.code == 200) {
                    this.$message.success('登录成功！')
                    Cookies.set('token', res.data)
                    const tokenKey = this.userType ? `token_${this.userType}` : 'token'
                    if (this.userType) {
                        Cookies.remove(`token_${this.userType}`)
                    }
                    Cookies.set(tokenKey, res.data)
                    this.clearFormErrors()
                    setTimeout(() => {
                        if (this.$route.query.type === 'agent' || this.$route.query.type === 'tenderee') {
                            this.$router.push('/agentHome')
                        } else {
                            this.$router.push('/bidderHome')
                        }
                    }, 500)
                } else {
                    this.$message.error(res.msg || '登录失败')
                }
            }).catch(error => {
                this.$message.error('登录失败，请重试')
                console.error('密码登录失败:', error)
            }).finally(() => {
                this.isLoading = false
            })
        },
        getCaptchaImageUrl() {
            if (this.forgotCaptchaImage) {
                return `data:image/jpeg;base64,${this.forgotCaptchaImage}`
            }
            return ''
        },
    }
}
</script>

<style lang="less" scoped>
.background-image {
    height: 100vh;
    background-image: url('../../../assets/image/new_slices/lgin_bg@2x.jpg');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;

    .content-wrap {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;

        .content-view {
            width: 490px;
            height: 603px;
            background: #fff;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            position: relative;

            .carousel-element {
                height: 603px;

                :deep(.el-carousel__item) {
                    height: 603px;
                }
            }

            .login-container {
                padding: 30px 40px;
                height: 100%;
                display: flex;
                flex-direction: column;

                .return-home {
                    display: flex;
                    text-align: right;
                    justify-content: flex-end;
                    align-items: center;

                    .home-icon {
                        width: 18px;
                        height: 18px;
                        margin-right: 3px;
                    }

                    .return-link {
                        color: #666;
                        text-decoration: none;
                        font-size: 14px;


                    }
                }

                .login-image {
                    width: 148px;
                    height: 49px;
                    margin: 0 auto;
                    margin-bottom: 49px;
                    margin-top: 35px;
                }

                .login-tabs {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 30px;

                    .tab-item {
                        padding: 10px 20px;
                        cursor: pointer;
                        color: #666;
                        font-size: 14px;
                        position: relative;
                        font-size: 18px;
                        font-weight: bold;

                        &.active {
                            color: #409EFF;

                            &::after {
                                content: '';
                                position: absolute;
                                bottom: -1px;
                                left: 0;
                                right: 0;
                                height: 2px;
                                background: #409EFF;
                            }
                        }

                        &:hover {
                            color: #409EFF;
                        }
                    }
                }

                .login-form {
                    flex: 1;
                    display: flex;
                    flex-direction: column;

                    .form-group {
                        margin-bottom: 20px;

                        .form-input {
                            width: 100%;
                            height: 45px;
                            border: 1px solid #ddd;
                            border-radius: 4px;
                            padding: 0 15px;
                            font-size: 14px;
                            box-sizing: border-box;
                            transition: border-color 0.3s ease, box-shadow 0.3s ease;

                            &:focus {
                                outline: none;
                                border-color: #409EFF;
                                box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                            }

                            &::placeholder {
                                color: #999;
                            }

                            &.error {
                                border-color: #f56c6c;

                                &:focus {
                                    border-color: #f56c6c;
                                    box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2);
                                }
                            }
                        }

                        .error-message {
                            color: #f56c6c;
                            font-size: 12px;
                            margin-top: 5px;
                            line-height: 1.4;
                        }

                    }

                    .forgot-links {
                        text-align: left;
                        margin-bottom: 25px;
                        font-size: 14px;

                        .forgot-link {
                            color: #656668;
                            text-decoration: none;

                            &:hover {
                                color: #409EFF;
                            }
                        }

                        .separator {
                            margin: 0 8px;
                            color: #656668;
                        }
                    }

                    .login-btn {
                        width: 100%;
                        height: 45px;
                        background: #005EEC;
                        color: white;
                        border: none;
                        border-radius: 4px;
                        font-size: 16px;
                        cursor: pointer;
                        margin-bottom: 20px;
                        transition: all 0.3s ease;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 8px;

                        &:hover:not(:disabled) {
                            background: #66b1ff;
                            transform: translateY(-1px);
                            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
                        }

                        &:disabled {
                            background: #c0c4cc;
                            cursor: not-allowed;
                            transform: none;
                            box-shadow: none;
                        }

                        .el-icon-loading {
                            animation: rotating 2s linear infinite;
                        }
                    }

                    @keyframes rotating {
                        0% {
                            transform: rotate(0deg);
                        }

                        100% {
                            transform: rotate(360deg);
                        }
                    }

                    .register-text {
                        text-align: center;
                        font-size: 14px;
                        color: #666;
                        margin-bottom: 30px;

                        .register-link {
                            color: #005EEC;
                            text-decoration: none;

                            &:hover {
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }
        }
    }
}

.forgot-form {
    .forgot-form-group {
        margin-bottom: 20px;
        display: flex;
        align-items: center;

        .forgot-form-label {
            flex-shrink: 0;
            width: 100px;
            margin-right: 12px;
            margin-bottom: 0;
            font-size: 14px;
            color: #333;
            text-align: right;
        }

        .forgot-input-group {
            flex: 1;
            display: flex;
            position: relative;
            height: 40px;

            .forgot-form-input {
                flex: 1;
                height: 40px;
                border: 1px solid #d9d9d9;
                border-radius: 4px;
                padding: 0 12px;
                font-size: 14px;
                box-sizing: border-box;
                outline: none;

                &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                }

                &::placeholder {
                    color: #bfbfbf;
                }
            }

            .forgot-captcha-image {
                position: absolute;
                right: 0;
                top: 0;
                width: 100px;
                height: 40px;
                border: 1px solid #d9d9d9;
                border-left: none;
                border-radius: 0 4px 4px 0;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fafafa;
                transition: all 0.3s ease;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 0 4px 4px 0;
                }

                &:hover {
                    background: #e6f7ff;
                }
            }

            .forgot-sms-btn {
                position: absolute;
                right: 0;
                top: 0;
                width: 120px;
                height: 40px;
                background: #409EFF;
                color: white;
                border: 1px solid #409EFF;
                border-left: none;
                border-radius: 0 4px 4px 0;
                font-size: 12px;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover:not(:disabled) {
                    background: #66b1ff;
                    border-color: #66b1ff;
                }

                &:disabled {
                    background: #c0c4cc;
                    border-color: #c0c4cc;
                    cursor: not-allowed;
                }
            }
        }
    }
}

.phone-unused-content {
    padding: 0;

    .phone-unused-message {
        margin: 0 0 16px 0;
        font-size: 14px;
        color: #333;
        line-height: 1.5;

        .email-address {
            color: #ff4d4f;
            font-weight: 500;
        }
    }

    .download-link {
        color: #ff4d4f;
        text-decoration: underline;
        font-size: 14px;
        cursor: pointer;
        transition: color 0.3s ease;
        float: left;
        margin-left: 15px;

        &:hover {
            color: #ff7875;
        }
    }
}
</style>